/**
 * Discard Transfer modal
* Created On: 14-11-2024
 */
import React from 'react';
import PropTypes from 'prop-types';

//  Motif controls
import MotifModal, { MotifModalHeader, MotifModalBody, MotifModalFooter } from '@ey-xd/motif-react/Modal';

import './DiscardTransfer.scss';

import iconWarning from "../../../../assets/images/warning.svg";
import { MotifButton } from '@ey-xd/motif-react';

const DiscardTransfer = ({
    discardModalShow,
    closeDiscardModal,
    discardResponseTransfer,
    discardTitle,
    discardMessage
}) => {

    return (
        <MotifModal
                        id="discardModal"
                        show={discardModalShow}
                        onClose={() => closeDiscardModal()}
                        size="sm"
                        className="confirmModal"
                    >
                    <MotifModalHeader className="discardHeader"
                        closeButtonProps={{
                            'aria-label': 'Close',
                            title: 'Close',
                            className: 'discardCloseButton'
                        }}
                        
                    >
                        <img src={iconWarning} alt="Warning icon" />
                        <div className="discardTitle">{discardTitle}</div>
                    </MotifModalHeader>
                    <MotifModalBody className="discardModalBody">
                        <span className="discardModalContent">
                            {discardMessage}
                        </span>
                    </MotifModalBody>
                    <MotifModalFooter className="discardModalFooter">
                        <MotifButton
                            label="btnCancel"
                            size="small"
                            type="button"
                            variant="secondary"
                            className="btnCancel"
                            onClick={() => closeDiscardModal()}
                        >
                            Cancel
                        </MotifButton>
                        <MotifButton
                            label="btnConfirm"
                            size="small"
                            type="button"
                            variant="primary"
                            className="btnConfirm"
                            onClick={() => discardResponseTransfer()}
                        >
                            Confirm
                        </MotifButton>
                    </MotifModalFooter>

                    </MotifModal>
        
    );
};

DiscardTransfer.propTypes = {
    discardModalShow: PropTypes.bool,
    closeDiscardModal: PropTypes.func,
    discardResponseTransfer: PropTypes.func,
    discardTitle: PropTypes.string,
    discardMessage: PropTypes.string
};

export default DiscardTransfer;